import { render, staticRenderFns } from "./RoomImagesSlide.vue?vue&type=template&id=4035fd76&"
import script from "./RoomImagesSlide.vue?vue&type=script&lang=js&"
export * from "./RoomImagesSlide.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports